'use strict';
import * as $j_app$002edata$002e$002dApp$002dDocument$002dData from "./app.data.-App-Document-Data.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentData$CertificateOfOrigin$() {
}
export { $c_Lapp_data_AppDocumentData$CertificateOfOrigin$ as $c_Lapp_data_AppDocumentData$CertificateOfOrigin$ };
$p = $c_Lapp_data_AppDocumentData$CertificateOfOrigin$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentData$CertificateOfOrigin$;
/** @constructor */
function $h_Lapp_data_AppDocumentData$CertificateOfOrigin$() {
}
export { $h_Lapp_data_AppDocumentData$CertificateOfOrigin$ as $h_Lapp_data_AppDocumentData$CertificateOfOrigin$ };
$h_Lapp_data_AppDocumentData$CertificateOfOrigin$.prototype = $p;
$p.n = (function() {
  return "CertificateOfOrigin";
});
$p.bK6 = (function(x$0) {
  return new $j_app$002edata$002e$002dApp$002dDocument$002dData.$c_Lapp_data_AppDocumentData$CertificateOfOrigin(x$0.e(0));
});
$p.U = (function(p) {
  return this.bK6(p);
});
var $d_Lapp_data_AppDocumentData$CertificateOfOrigin$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentData$CertificateOfOrigin$, "app.data.AppDocumentData$CertificateOfOrigin$", ({
  zL: 1,
  d: 1,
  e: 1
}));
export { $d_Lapp_data_AppDocumentData$CertificateOfOrigin$ as $d_Lapp_data_AppDocumentData$CertificateOfOrigin$ };
var $n_Lapp_data_AppDocumentData$CertificateOfOrigin$;
function $m_Lapp_data_AppDocumentData$CertificateOfOrigin$() {
  if ((!$n_Lapp_data_AppDocumentData$CertificateOfOrigin$)) {
    $n_Lapp_data_AppDocumentData$CertificateOfOrigin$ = new $c_Lapp_data_AppDocumentData$CertificateOfOrigin$();
  }
  return $n_Lapp_data_AppDocumentData$CertificateOfOrigin$;
}
export { $m_Lapp_data_AppDocumentData$CertificateOfOrigin$ as $m_Lapp_data_AppDocumentData$CertificateOfOrigin$ };
//# sourceMappingURL=app.data.-App-Document-Data$-Certificate-Of-Origin$.js.map
